import { h, Component } from 'preact';
import Store from 'store/store';
import s from 'components/bolt/downWorld/lever/lever.sss';


const SPRITESHEET_WIDTH = 1024;
const SPRITESHEET_HEIGHT = 2048;
const FRAME_WIDTH = 145;
const FRAME_HEIGHT = 408;
const X_STEP = 146;
const Y_STEP = 409;
const FRAME_LENGTH = 33;
const COLS = 7;
const FRAME_SHEET_WIDTH_SCALE_FACTOR = SPRITESHEET_WIDTH / FRAME_WIDTH;
const FRAME_SHEET_HEIGHT_SCALE_FACTOR = SPRITESHEET_HEIGHT / FRAME_HEIGHT;


export default class Lever extends Component {
	constructor() {
		super();
		this.onSlotMachinePull = this.onSlotMachinePull.bind(this);
		this.onLeverHover = this.onLeverHover.bind(this);
		this.onLeverUnhover = this.onLeverUnhover.bind(this);
		this.animateLever = this.animateLever.bind(this);
		this.peekAnimateLever = this.peekAnimateLever.bind(this);
		this.reversePeekAnimateLever = this.reversePeekAnimateLever.bind(this);
		this.state = {
			frame: 0
		};
	}

	componentDidMount() {
		Store.on('SLOT_MACHINE_PULL', this.onSlotMachinePull);
		Store.on('HOVER_LEVER', this.onLeverHover);
		Store.on('UNHOVER_LEVER', this.onLeverUnhover);
	}

	componentWillUnmount() {
		Store.off('SLOT_MACHINE_PULL', this.onSlotMachinePull);
		Store.off('HOVER_LEVER', this.onLeverHover);
		Store.off('UNHOVER_LEVER', this.onLeverUnhover);
		this.animateLeverTimer && clearTimeout(this.animateLeverTimer);
		this.peekAnimateLeverTimer && clearTimeout(this.peekAnimateLeverTimer);
		this.reversePeekAnimateLeverTimer && clearTimeout(this.reversePeekAnimateLeverTimer);
	}

	onSlotMachinePull() {
		const { frame } = this.state;
		if (frame > 2) {
			this.setState({ frame: 0 });
		}
		this.animateLever();
	}

	onLeverHover() {
		this.peekAnimateLever();
	}

	onLeverUnhover() {
		this.reversePeekAnimateLever();
	}

	getFrameTransform() {
		const { frame } = this.state;
		const row = Math.floor(frame / COLS);
		const col = frame % COLS;
		const x = -col * X_STEP;
		const y = -row * Y_STEP;
		return {
			xPercent: (x / SPRITESHEET_WIDTH) * 100,
			yPercent: (y / SPRITESHEET_HEIGHT) * 100
		}; 
	}

	animateLever() {
		const { frame } = this.state;
		if (frame >= FRAME_LENGTH - 1) {
			this.setState({ frame: 0 });
			return;
		}
		this.setState({ frame: frame + 1 });
		this.animateLeverTimer = setTimeout(this.animateLever, 1000 / 30);
	}

	peekAnimateLever() {
		if (this.unpeeking) return;
		const { frame } = this.state;
		const frameLimitIndex = 2;
		if (frame >= frameLimitIndex) {
			this.peeking = false;
			return;
		}
		this.peeking = true;
		this.setState({ frame: frame + 1 });
		this.peekAnimateLeverTimer = setTimeout(this.peekAnimateLever, 1000 / 30);
	}

	reversePeekAnimateLever() {
		const { frame } = this.state;
		if (frame <= 0) {
			this.unpeeking = false;
			return;
		}
		this.unpeeking = true;
		this.setState({ frame: frame - 1 });
		this.reversePeekAnimateLeverTimer = setTimeout(this.reversePeekAnimateLever, 1000 / 30);
	}

	render({ imageRoot }) {
		const frameTransformVals = this.getFrameTransform();
		return (
			<div class={s.container}>
				<img
					class={s.spritesheet}
					src={`${imageRoot}/down/lever-spritesheet.webp`}
					style={{
						width: `${FRAME_SHEET_WIDTH_SCALE_FACTOR * 100}%`,
						height: `${FRAME_SHEET_HEIGHT_SCALE_FACTOR * 100}%`,
						transform: `translate(${frameTransformVals.xPercent}%, ${frameTransformVals.yPercent}%)`
					}}
				/>
			</div>
		);
	}
}